// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a08bbd13","732":"81da3204","977":"3287b7f2"}[chunkId] + ".chunk.js";
};